import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import { fileDownload } from "../../api/file";
import { Document, DownloadCloud } from "../../assets/icons";
import { TableList } from "../../components";
import { useApi } from "../../context/context";
import { cipDateFormat } from "../../utils";

const Invoices = () => {
  const { invoices } = useApi();
  const { t } = useTranslation();

  // console.log("invoices", invoices);

  // http://81.228.120.21:8000/cipfiles/PROD/Invoices/Invoice-406394.pdf
  // https://fmdoc01prod.mtab.se/file/CipFiles/Invoices/Invoice-406394.pdf
  // http://localhost:9000/file?path=49b3ed4b-1080-45f5-9c4b-8fb03fb18b3e.pdf&service=external&filename=dummy.pdf

  return (
    <>
      <Typography variant="h1" color="primary.main">
        {t("invoices")}
      </Typography>
      <TableList
        data={invoices}
        canUpload={false}
        columns={[
          {
            name: "InvoiceNumber",
            title: "#",
            modifier: (v) => (
              <>
                <span className="td-icon">
                  <Document />
                </span>{" "}
                {v}
              </>
            )
          },
          {
            name: "InvoiceDate",
            title: "Date",
            modifier: cipDateFormat
          },
          {
            name: "Description",
            title: "Description",
            modifier: (v) => <strong>{v}</strong>
          },
          {
            name: "ProjectIDs",
            title: "Project ID"
          },
          {
            name: "SumExVAT",
            title: "Amount (ex Vat)",
            modifier: (v) => v + " SEK"
          },
          {
            name: "InvoiceNumber",
            title: "Download",
            modifier: (v) => (
              <a
                target="_blank"
                download
                href={fileDownload(
                  "Invoices/invoice-" + v + ".pdf",
                  "external",
                  "invoice-" + v + ".pdf"
                )}
                style={{ paddingRight: "10px" }}
                rel="noreferrer"
              >
                <DownloadCloud />
              </a>
            )
          }
        ]}
      />
    </>
  );
};

export default Invoices;
